import { SimpleLogger } from "@plans/appkit";

// #TODO: fix issue where stacktraces are not logged properly
export const logger = new SimpleLogger(process.env.NODE_ENV, "REMIX");
